import { useEffect, useMemo } from 'react';

import config from 'config';
import { useSelector } from 'react-redux';

import { useDomain } from '../../redux-core';

import { getMembership } from './accountsModule';
import useAccountActions from './useAccountActions';

export default function useMembership() {
  const actions = useAccountActions();
  const membership = useSelector(getMembership);
  const { tld } = useDomain();

  const globalMembershipPrice = config.get(
    'public.brand.globalMembershipPrice'
  );

  useEffect(() => {
    if (!membership.networkStatus.isUpToDate) {
      actions.loadMembership();
    }
  }, [actions, membership.networkStatus.isUpToDate]);

  const memoizedMembership = useMemo(() => {
    const updatedMembership = { ...membership };

    if (!updatedMembership.price && globalMembershipPrice?.[tld]) {
      updatedMembership.price = globalMembershipPrice[tld];
    }

    return updatedMembership;
  }, [membership, globalMembershipPrice, tld]);

  return memoizedMembership;
}
